import Section from '../../components/Section'
import CsPersonSearch from '../../uiV2/person/search/CsPersonSearch'

export default function PersonColdStorage(): React.JSX.Element {
    return (
        <div className="mt-6">
            <Section subtitle="Person Cold Storage">
                <CsPersonSearch
                    allowEmptyQuery={true}
                    minQueryLength={0}
                    enableUrlSync={true}
                    allowImport={true}
                    allowNetworkImport={true}
                    allowGenerateNetwork={true}
                    enableWorkHistoryLinks={true}
                    enableWorkHistoryFilters={true}
                />
            </Section>
        </div>
    )
}
